import {
	getExperimentTreatment,
	isExperimentActive,
} from '@sparefoot/react-core/utils/experiment';
import { TrackingClient } from '@sparefoot/tracking-client';
import { keys, map } from 'lodash';

export const trackExperiment = (
	eventName,
	experimentName,
	experimentVariation,
) => {
	TrackingClient.trackExperimentView({
		event: eventName,
		category: experimentName,
		label: `Phlag ${experimentName} ${experimentVariation}`,
		experiment_source: 'Phlag',
		experiment_id: experimentName,
		variant_id: experimentVariation,
	});
};

export const logExperimentBucketing = (bucket) => {
	map(keys(bucket), (name) => {
		if (isExperimentActive(name, bucket)) {
			trackExperiment(
				'experiment_bucketing',
				name,
				getExperimentTreatment(name, bucket),
			);
		}
	});
};
